import { Typography } from "@material-ui/core";
import React from "react";

const RefereeTableDefaultCell = ({ content }) => {
    return <Typography>{content}</Typography>;
};

export default React.memo(RefereeTableDefaultCell);
